export const isBase64 = (value: any) => typeof value === 'string' && value?.includes('base64');
